import { createSlice } from "@reduxjs/toolkit";
import { fetchUserRateMappings } from "../Thunks/userRateMappingThunk";
import { addAsyncResourceThunk } from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const userRateMappingSlice = createSlice({
  name: "userRateMapping",
  initialState,
  reducers: {
    clearUserRateMappings: (state) => {
      state.data = null;
      state.error = null;
    },
    addUserRateMapping: (state, action) => {
      const newItem = action.payload;
      if (!state.data) {
        state.data = { list: [newItem], totalCount: 1 };
        return;
      }
      if (!Array.isArray(state.data.list)) {
        state.data.list = [];
      }
      state.data.list.push(newItem);
      if (typeof state.data.totalCount === "number") {
        state.data.totalCount += 1;
      }
    },
    deleteUserRateMapping: (state, action) => {
      const id = action.payload;
      if (!state.data?.list) return;
      state.data.list = state.data.list.filter((row) => row.id !== id);
      if (typeof state.data.totalCount === "number") {
        state.data.totalCount = Math.max(0, state.data.totalCount - 1);
      }
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchUserRateMappings);
  },
});

export const { clearUserRateMappings, addUserRateMapping, deleteUserRateMapping } =
  userRateMappingSlice.actions;

export const selectUserRateMappingData = (state) => state.userRateMapping.data;
export const selectUserRateMappingLoading = (state) => state.userRateMapping.loading;
export const selectUserRateMappingError = (state) => state.userRateMapping.error;

export default userRateMappingSlice.reducer;
